export default __webpack_public_path__ + "static/media/html-5.ebfc51e4.svg";